/**
 * NjitSteppedContent behaviour.
 */

(function (Drupal, $) {
  "use strict";

  Drupal = Drupal || {};

  Drupal.settings = Drupal.settings || {};

  /**
   * JS Behaviour.
   *
   * @type {{attach: Drupal.behaviors.NjitSteppedContent.attach}}
   */
  Drupal.behaviors.NjitSteppedContent = {
    attach: function (context, settings) {
      // Copy the HTML from tab content to tab nav for mobile display purpose.
      var steppedContent = $('.stepped-content');
      if(steppedContent.attr('data-processed')!="true"){ 
      $('.tab-contents .tab-content', steppedContent).each(function() {
        var tabName = $(this).attr('rel');
        var tabHtml = $(this).html();
        $('.tab-nav ul li[data-target="' + tabName + '"]')
          .append('<div class="tab-contents"><div class="tab-content clearfix">' + tabHtml + '</div></div>');
      });
      }
      steppedContent.attr('data-processed',"true");
    }
  };
})(Drupal, jQuery);